export const loaderTranslation = {
    withMusic: {
        en : "Continue WITH Music",
        he: "המשך עם מוזיקה",
        ar: "قم بتشغيل موسيقى",
    },
    withoutMusic : {
        en: "Continue WITHOUT Music",
        he: "המשך בלי מוזיקה",
        ar: "أكمل دون موسيقى",
    }
}